import React from 'react';
import { useIntl } from 'react-intl';

import Paper from '@material-ui/core/Paper';
import PrimaryButton from 'components/Shared/Buttons/PrimaryButton';

import RateCandidateSvg from 'assets/rate-candidate.svg';

import './RateCandidateBanner.scss';

const RateCandidateBanner = ({
    handleRateCandidateClick,
}) => {
    const intl = useIntl();

    return (
        <div className="rate-candidate-banner-wrapper">
            <Paper className="rate-candidate-container">
                <div className="rate-candidate-data">
                    <div className="text">
                        {intl.formatMessage({ id: "rate-candidate-banner-text" })}
                    </div>
                    <div className="rate-candidate-button-wrapper">
                            <PrimaryButton
                                text={intl.formatMessage({ id: "rate-candidate" })}
                                handleClick={event => handleRateCandidateClick(event)}
                            />
                        </div>
                </div>
                <img src={RateCandidateSvg} className="rate-candidate-img"/>
            </Paper>
        </div>
    )
};

export default RateCandidateBanner;
